export default "__VITE_ASSET__CiBOsbxJ__"